export default __webpack_public_path__ + "static/media/Icon-react.3eee60b7.svg";